import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import {
  BorderedTablePaper,
  DynamicHeightContainer,
} from "@/pages/heat-report/styles/HeatReportStyledComponents";
import { Box, Grid } from "@mui/material";
import { Column, GridReadyEvent, ColumnResizedEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "./hooks/useTableData";
import { useMemo, useState } from "react";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const TorchesTable = () => {
  const {
    state: { casProcessData, torches },
  } = useHeatReportContext();

  const rowCount = torches?.length || 0;

  const [columnData, setColumnData] = useState<
    { colId: string | undefined; width: number }[]
  >([]);

  const totals = useMemo(
    () => ({
      cuts: torches.reduce((sum, torch) => sum + (torch.TotalCuts || 0), 0),
      unidentified: torches.reduce(
        (sum, torch) => sum + (torch.Undefined || 0),
        0,
      ),
      scrapped: torches.reduce((sum, torch) => sum + (torch.Scrapped || 0), 0),
      billets: torches.reduce((sum, torch) => sum + (torch.Billets || 0), 0),
    }),
    [torches],
  );

  const { columns } = useTableData();
  return (
    <BorderedTablePaper elevation={0}>
      <Box p={1}>
        <DynamicHeightContainer
          rowCount={rowCount}
          key={`${torches.length}-${casProcessData.ProcessId}`}
        >
          <AgGridReact
            rowData={torches}
            columnDefs={columns}
            defaultColDef={defaultColDef}
            onGridReady={(params: GridReadyEvent) => {
              const columns = params.api.getAllDisplayedColumns();
              const newColumnData = columns?.map((col: Column) => ({
                colId: col.getColId(),
                width: col.getActualWidth(),
              }));
              setColumnData(newColumnData || []);
            }}
            onColumnResized={(params: ColumnResizedEvent) => {
              const columns = params.api.getAllDisplayedColumns();
              const newColumnData = columns?.map((col: Column) => ({
                colId: col.getColId(),
                width: col.getActualWidth(),
              }));
              setColumnData(newColumnData || []);
            }}
            {...defaultGridOptions}
          />
          <Grid
            container
            wrap="nowrap"
            sx={{
              display: "flex",
              width: "100%",
              marginTop: 1.5,
            }}
          >
            {columnData.map((col, index) => (
              <Grid
                key={col.colId}
                sx={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 0.5,
                  fontWeight: "bold",
                  width: `${col.width}px`,
                  minWidth: `${col.width}px`,
                  maxWidth: `${col.width}px`,
                }}
              >
                {index === 5
                  ? "Totals"
                  : col.colId === "TotalCuts"
                    ? totals.cuts
                    : col.colId === "Undefined"
                      ? totals.unidentified
                      : col.colId === "Scrapped"
                        ? totals.scrapped
                        : col.colId === "Billets"
                          ? totals.billets
                          : ""}
              </Grid>
            ))}
          </Grid>
        </DynamicHeightContainer>
      </Box>
    </BorderedTablePaper>
  );
};
